import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSearchQuery } from '~/common/hooks/useSearchQuery'

type UseNavigateWithSearchString = (pathname: string, search?: string | number) => void

export const useNavigateWithSearchString = (useUrlSearch = false): UseNavigateWithSearchString => {
  const search = useSearchQuery()
  const navigate = useNavigate()

  const fallback = useUrlSearch ? search : undefined

  return useCallback(
    (pathname: string, searchString?: string | number) => {
      const search = searchString ?? fallback
      return navigate({ pathname, search: search ? `search=${search}` : '' })
    },
    [fallback]
  )
}
